import { Navbar } from '../components/Navbar.tsx';
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { FiCoffee } from "react-icons/fi";
import { Toaster, toast } from 'alert';
import { Footer } from "../components/Footer.tsx";

function Login() {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const navigate = useNavigate()
    const api = "https://backend.coffeelatek.com";

    const submit = () => {
        axios.post(api + "/api/login", {
            username: username,
            password: password
        }
        ).then(
            res => {
                if (res.status == 200 || res.status == 201) {
                    localStorage.setItem("userId", res.data["userId"])
                    localStorage.setItem("token", res.data["token"])
                    navigate("/search")
                } else {
                    toast.error("try logging in again, an error has occured")
                }
            }
        ).catch(
            function (error) {
                toast.error("internal server error")
            }
        )
    }

    const handleCtrl = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            submit()
        }
    }

    useEffect(() => {
        if (localStorage.getItem("token") != undefined) {
            navigate("/search")
        }
        document.addEventListener('keydown', handleCtrl);
        return () => {
            document.removeEventListener('keydown', handleCtrl);
        }
    })

    const handleUsername = (e) => {
        setUsername(e.target.value)
    }

    const handlePassword = (e) => {
        setPassword(e.target.value)
    }

    return (
        <>
            <Navbar />
            <Toaster position='top-center' />
            
            <div className="login-page">
                <div className="login-card">
                    <div className="logo">
                        <FiCoffee size={40} color="var(--primary-color)" />
                    </div>
                    <h1>Welcome Back</h1>
                    <p className="subtitle text-muted">Log in to your CoffeeLaTek account</p>

                    <div className="form-group">
                        <label>Username</label>
                        <input 
                            placeholder="Enter your username" 
                            onChange={handleUsername} 
                            style={{ width: '100%' }}
                        />
                    </div>
                    
                    <div className="form-group">
                        <div className="form-group-header">
                            <label>Password</label>
                        </div>
                        <input 
                            placeholder="Enter your password" 
                            type='password' 
                            onChange={handlePassword} 
                            style={{ width: '100%' }}
                        />
                    </div>
                    
                    <button className="button" style={{ width: '100%' }} onClick={submit}>
                        Log In
                    </button>
                    
                    <div className="text-center mt-2">
                        <span className="text-muted">Don't have an account? </span>
                        <a href="/signup">Sign up</a>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Login; 